"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var Container = /** @class */ (function () {
    function Container() {
        this.data = {};
    }
    Container.prototype.set = function (key, value) {
        this.data[key] = value;
    };
    Container.prototype.get = function (key) {
        return this.data[key];
    };
    return Container;
}());
exports.Container = Container;
